<head-single-property [idbien]="idprop"></head-single-property>
<!-- Property Details Hero Section Begin -->

<!-- Property Details Section Begin -->
<section class="property-details-section spad">
    <div class="container">
        <div class="row">
            <div class="col-lg-9">
                <div class="pd-details-text">
                    <div class="pd-details-social">
                        <a href="#"><i class="fa fa-facebook"></i></a>
                        <a href="#"><i class="fa fa-send"></i></a>
                        <a href="#"><i class="fa fa-star"></i></a>
                        <a href="#"><i class="fa fa-print"></i></a>
                        <a href="#"><i class="fa fa-cloud-download"></i></a>
                    </div>

                    <nb-card>
                        <div class="property-more-pic">

                            <nb-tabset>
                                <nb-tab [tabTitle]="'PROPERTY_DETAILS.PHOTOS' | translate" tabIcon="image-outline"
                                    responsive>
                                    <gallery id="propertyGallery" [thumbTemplate]="thumbTemplate"
                                        [itemTemplate]="itemTemplate">
                                    </gallery>

                                    <!-- Add custom template to thumbnails -->
                                    <ng-template #thumbTemplate let-type="type">
                                        <span *ngIf="type === 'youtube'" class="item-type">
                                            <fa-icon [icon]="youtubeIcon" size="lg"></fa-icon>
                                        </span>
                                        <span *ngIf="type === 'video'" class="item-type">
                                            <fa-icon [icon]="videoIcon" size="lg"></fa-icon>
                                        </span>
                                    </ng-template>

                                    <!-- Add custom template to image items -->
                                    <ng-template #itemTemplate let-index="index" let-type="type" let-data="data"
                                        let-currIndex="currIndex">


                                        <span *ngIf="type === 'image' && index === currIndex" [@enterAnimation]
                                            class=" ">
                                            <div _ngcontent-wxd-c51="" class="pic-tag" style="-webkit-tap-highlight-color: transparent;
                                                                                                background: #20c997;
                                                                                                display: inline-block;
                                                                                                padding: 4px 15px; ">
                                                <div _ngcontent-wxd-c51="" class="f-text"><b _ngcontent-wxd-c51="">
                                                        {{data?.title}}</b>
                                                </div>
                                            </div>
                                        </span>
                                    </ng-template>
                                </nb-tab>
                                <nb-tab [tabTitle]="'PROPERTY_DETAILS.VIRTUAL_TOUR' | translate" tabIcon="eye-outline"
                                    ng-hide="visite360" responsive disabled="visite360">
                                    <gallery id="propertytourGallery" [thumb]="false" [itemTemplate]="itemTemplate">
                                    </gallery>
                                    <!-- Add custom template to image items -->
                                    <ng-template #itemTemplate let-index="index" let-type="type" let-data="data"
                                        let-currIndex="currIndex">
                                        <span *ngIf="type === 'image' && index === currIndex" [@slideAnimation]
                                            class="item-text">
                                            <div _ngcontent-sut-c68="" class="pd-hero-text">
                                                {{data?.title}}
                                            </div>
                                        </span>
                                    </ng-template>
                                </nb-tab>
                                <nb-tab [tabTitle]="'PROPERTY_DETAILS.VIDEO_TOUR' | translate" tabIcon="video-outline"
                                    ng-hide="visite360" responsive disabled="visite360">
                                    <!-- Add custom template to image items -->
                                    <video controls width="100%" height="600">
                                        <source [src]="videosource" type="video/mp4" />
                                        {{ 'PROPERTY_DETAILS.VIDEO_ERROR' | translate }}
                                    </video>
                                </nb-tab>
                            </nb-tabset>

                        </div>
                    </nb-card>



                    <nb-card>
                        <nb-card-body>
                            <div class="pd-desc">
                                <h4>{{ 'PROPERTY_DETAILS.DESCRIPTION' | translate }}</h4>
                                <div class="row">
                                    <div class="cole-lg-6 col-md-6 col-sm-12">

                                        <nb-list>
                                            <nb-list-item *ngFor='let elt of descriptifs.split("\n") | slice:0:9'>
                                                <nb-icon icon="checkmark-circle-outline" status="success"></nb-icon>
                                                  {{elt }}
                                            </nb-list-item>
                                        </nb-list>
                                    </div>
                                    <div class="cole-lg-6 col-md-6 col-sm-12">
                                        <nb-list>
                                            <nb-list-item *ngFor='let elt of descriptifs.split("\n") | slice:9:18'>
                                                <nb-icon icon="checkmark-circle-outline" status="success"></nb-icon>
                                                  {{ elt }}
                                            </nb-list-item>
                                        </nb-list>
                                    </div>
                                </div>
                            </div>
                        </nb-card-body>
                    </nb-card>
                    <nb-card>
                        <nb-card-header>
                            <h4>{{ 'PROPERTY_DETAILS.CHARACTERISTICS' | translate }}</h4>
                        </nb-card-header>
                        <nb-card-body>

                            <nb-accordion multi>
                                <nb-accordion-item>
                                    <nb-accordion-item-header>
                                        {{ 'PROPERTY_DETAILS.ROOMS' | translate }}
                                    </nb-accordion-item-header>
                                    <nb-accordion-item-body>
                                        <div class="row">
                                            <div class="col-lg-6  ">
                                                <nb-list>
                                                    <nb-list-item>
                                                        <i class="fa fa-bed"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.BEDROOMS' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.nbrchambreacoucher}}
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <i class="fa fa-bath"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.BATHROOMS' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.nbrsallebain}}
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <i class="fa fa-coffee"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.ROOMS' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.nbrpiece}}
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <i class="fa fa-coffee"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.FLOOR' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.localisationetage}}<sup>
                                                            ième </sup>{{ 'PROPERTY_DETAILS.FLOOR_SUFFIX' | translate }}
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <nb-icon icon="globe-2"
                                                            style="    font-size: 24px; color: #2cbdb8;"></nb-icon>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.BEDROOMS_COUNT' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.nbrchambreacoucher}}
                                                    </nb-list-item>

                                                </nb-list>
                                            </div>
                                            <div class="col-lg-6  ">
                                                <nb-list>
                                                    <nb-list-item>
                                                        <nb-icon icon="home"
                                                            style="    font-size: 24px; color: #2cbdb8;"></nb-icon>
                                                        &nbsp;&nbsp;<b> {{ 'PROPERTY_DETAILS.LIVING_ROOM' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.nbrsalon}}
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <nb-icon icon="activity"
                                                            style="    font-size: 24px; color: #2cbdb8;"></nb-icon>
                                                        &nbsp;&nbsp;<b>{{ 'PROPERTY_DETAILS.FLOORS' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.nbreetage}}
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <i class="fa fa-car"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.PARKING' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.parking ?
                                                        ('PROPERTY_DETAILS.YES' | translate) : ('PROPERTY_DETAILS.NO' |
                                                        translate)}}

                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <i class="fa fa-reorder"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.GARAGE' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; <b>{{Bien?.garage ?
                                                            ('PROPERTY_DETAILS.YES' | translate) :
                                                            ('PROPERTY_DETAILS.NO' | translate)}} (01) </b>
                                                    </nb-list-item>

                                                </nb-list>
                                            </div>

                                        </div>
                                    </nb-accordion-item-body>
                                </nb-accordion-item>

                                <nb-accordion-item>
                                    <nb-accordion-item-header>
                                        {{ 'PROPERTY_DETAILS.RENT_PURCHASE' | translate }}
                                    </nb-accordion-item-header>
                                    <nb-accordion-item-body>
                                        <div class="row">
                                            <div class="col-lg-6  ">
                                                <nb-list>
                                                    <nb-list-item>
                                                        <i class="fa fa-money"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;
                                                        &nbsp;&nbsp;<b>{{ 'PROPERTY_DETAILS.COST' | translate }} {{ 'COMMON.COST_UNITS.' + 
                                                            (unitecout === 'par heure' ? 'PER_HOUR' : 
                                                             unitecout === 'journalier' ? 'DAILY' : 
                                                             unitecout === 'par mètre carré' ? 'PER_SQUARE_METER' : 
                                                             unitecout === 'mensuel' ? 'MONTHLY' : 
                                                             unitecout === 'horaire' ? 'HOURLY' : 
                                                             unitecout === 'de vente' ? 'FOR_SALE' : 
                                                             unitecout === 'hebdomadaire' ? 'WEEKLY' : 'MONTHLY') | translate }}:</b>&nbsp;&nbsp;&nbsp;
                                                        <strong>{{coutloyermensuel | currency:'XAF'}} </strong>

                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <i class="fa fa-money"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;
                                                        &nbsp;&nbsp;<b>{{ 'PROPERTY_DETAILS.PAYMENT' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp;
                                                        <strong> {{Bien?.modepaiement}} </strong>

                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <i class="fa fa-file-text"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.CONTRACT' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; <b>{{avendre ?
                                                            ('PROPERTY_DETAILS.FOR_SALE' | translate) :
                                                            ('PROPERTY_DETAILS.FOR_RENT' | translate)}}</b>
                                                    </nb-list-item>

                                                </nb-list>
                                            </div>
                                            <div class="col-lg-6  ">
                                                <nb-list>
                                                    <nb-list-item>
                                                        <i class="fa fa-exclamation-circle"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.ADVANCE_MONTHS' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.avances}}
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <i class="fa fa-ban"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.DEPOSIT_MONTHS' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.avances/5}}

                                                    </nb-list-item>

                                                </nb-list>
                                            </div>

                                        </div>
                                    </nb-accordion-item-body>
                                </nb-accordion-item>

                                <nb-accordion-item>
                                    <nb-accordion-item-header>
                                        {{ 'PROPERTY_DETAILS.LOCATION' | translate }}
                                    </nb-accordion-item-header>
                                    <nb-accordion-item-body>

                                        <div class="row">
                                            <div class="col-lg-6  ">
                                                <nb-list>
                                                    <nb-list-item>
                                                        <i class="fa fa-map-marker"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;
                                                        &nbsp;&nbsp;<b> {{ 'PROPERTY_DETAILS.COUNTRY' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{ 'PROPERTY_DETAILS.CAMEROON' |
                                                        translate }}
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <i class="fa fa-map-marker"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            {{ 'PROPERTY_DETAILS.CITY' | translate
                                                            }}:</b>&nbsp;&nbsp;&nbsp; {{Bien?.ville?.nomville}}
                                                    </nb-list-item>
                                                    <!--
                                                    <nb-list-item>
                                                        <i class="fa fa-map-marker"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                            Region :</b>&nbsp;&nbsp;&nbsp; Centre
                                                    </nb-list-item>
                                                    -->

                                                </nb-list>
                                            </div>
                                            <div class="col-lg-6  ">
                                                <nb-list>
                                                    <nb-list-item>
                                                        <i class="fa fa-map-marker"
                                                            style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;
                                                        <b> {{ 'PROPERTY_DETAILS.DISTRICT' | translate }}: </b>
                                                        &nbsp;&nbsp;&nbsp;
                                                        {{Bien?.quartier?.nomquartier}}
                                                    </nb-list-item>

                                                </nb-list>
                                            </div>

                                        </div>
                                    </nb-accordion-item-body>
                                </nb-accordion-item>

                                <nb-accordion-item>
                                    <nb-accordion-item-header>
                                        {{ 'PROPERTY_DETAILS.AMENITIES' | translate }}
                                    </nb-accordion-item-header>
                                    <nb-accordion-item-body>
                                        <div class="row">
                                            <div class="col-lg-6  ">
                                                <nb-list>
                                                    <nb-list-item>
                                                        <nb-icon *ngIf="Bien?.sallebainpartage"
                                                            icon="checkmark-square-2-outline"
                                                            status="success"></nb-icon>
                                                        <nb-icon *ngIf="!Bien?.sallebainpartage"
                                                            icon="minus-square-outline" status="danger"></nb-icon>
                                                        {{ 'PROPERTY_DETAILS.SHARED_BATHROOM' | translate }} :
                                                        <b>{{Bien?.sallebainpartage ? ('PROPERTY_DETAILS.YES' |
                                                            translate) : ('PROPERTY_DETAILS.NO' | translate)}}</b>
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <nb-icon *ngIf="Bien?.estmeuble"
                                                            icon="checkmark-square-2-outline"
                                                            status="success"></nb-icon>
                                                        <nb-icon *ngIf="!Bien?.estmeuble" icon="minus-square-outline"
                                                            status="danger"></nb-icon>
                                                        {{ 'PROPERTY_DETAILS.FURNISHED' | translate }} :
                                                        <b>{{Bien?.estmeuble ? ('PROPERTY_DETAILS.YES' | translate) :
                                                            ('PROPERTY_DETAILS.NO' | translate)}}</b>
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <nb-icon *ngIf="Bien?.achauffage"
                                                            icon="checkmark-square-2-outline"
                                                            status="success"></nb-icon>
                                                        <nb-icon *ngIf="!Bien?.achauffage" icon="minus-square-outline"
                                                            status="danger"></nb-icon>
                                                        {{ 'PROPERTY_DETAILS.HEATING' | translate }} :
                                                        <b>{{Bien?.achauffage ? ('PROPERTY_DETAILS.YES' | translate) :
                                                            ('PROPERTY_DETAILS.NO' | translate)}}</b>
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <nb-icon *ngIf="Bien?.balcon" icon="checkmark-square-2-outline"
                                                            status="success"></nb-icon>
                                                        <nb-icon *ngIf="!Bien?.balcon" icon="minus-square-outline"
                                                            status="danger"></nb-icon>
                                                        {{ 'PROPERTY_DETAILS.BALCONY' | translate }} : <b>{{Bien?.balcon
                                                            ? ('PROPERTY_DETAILS.YES' | translate) :
                                                            ('PROPERTY_DETAILS.NO' | translate)}}</b>
                                                    </nb-list-item>

                                                </nb-list>
                                            </div>
                                            <div class="col-lg-6  ">
                                                <nb-list>
                                                    <nb-list-item>
                                                        <nb-icon *ngIf="Bien?.buanderie"
                                                            icon="checkmark-square-2-outline"
                                                            status="success"></nb-icon>
                                                        <nb-icon *ngIf="!Bien?.buanderie" icon="minus-square-outline"
                                                            status="danger"></nb-icon>
                                                        {{ 'PROPERTY_DETAILS.LAUNDRY' | translate }} :
                                                        <b>{{Bien?.buanderie ? ('PROPERTY_DETAILS.YES' | translate) :
                                                            ('PROPERTY_DETAILS.NO' | translate)}}</b>
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <nb-icon *ngIf="Bien?.estdisponible"
                                                            icon="checkmark-square-2-outline"
                                                            status="success"></nb-icon>
                                                        <nb-icon *ngIf="!Bien?.estdisponible"
                                                            icon="minus-square-outline" status="danger"></nb-icon>
                                                        {{ 'PROPERTY_DETAILS.AVAILABLE' | translate }} :
                                                        <b>{{Bien?.estdisponible ? ('PROPERTY_DETAILS.YES' | translate)
                                                            : ('PROPERTY_DETAILS.NO' | translate)}}</b>
                                                    </nb-list-item>
                                                    <nb-list-item>
                                                        <nb-icon *ngIf="Bien?.terasse" icon="checkmark-square-2-outline"
                                                            status="success"></nb-icon>
                                                        <nb-icon *ngIf="!Bien?.terasse" icon="minus-square-outline"
                                                            status="danger"></nb-icon>
                                                        {{ 'PROPERTY_DETAILS.TERRACE' | translate }} :
                                                        <b>{{Bien?.terasse ? ('PROPERTY_DETAILS.YES' | translate) :
                                                            ('PROPERTY_DETAILS.NO' | translate)}}</b>
                                                    </nb-list-item>


                                                </nb-list>
                                            </div>
                                        </div>
                                    </nb-accordion-item-body>

                                </nb-accordion-item>
                                <nb-accordion-item>
                                    <nb-accordion-item-header>
                                        {{ 'PROPERTY_DETAILS.PROPERTY_TYPE_CATEGORY' | translate }}
                                    </nb-accordion-item-header>
                                    <nb-accordion-item-body>
                                        <nb-list>
                                            <nb-list-item>
                                                <i class="fa  fa-exclamation-circle"
                                                    style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;
                                                &nbsp;&nbsp;<b> {{ 'PROPERTY_DETAILS.PROPERTY_TYPE' | translate
                                                    }}:</b>&nbsp;&nbsp;&nbsp;
                                                {{gData.getTranslatedCategoryName(Bien?.category?.nomcategorie)}}
                                            </nb-list-item>
                                            <nb-list-item>
                                                <i class="fa fa-ban"
                                                    style="    font-size: 24px; color: #2cbdb8;"></i>&nbsp;&nbsp;<b>
                                                    {{ 'PROPERTY_DETAILS.CATEGORY' | translate }}:</b>&nbsp;&nbsp;&nbsp;
                                                    {{gData.getTranslatedPropertyType(Bien?.typelogement?.nomtypelogement)}}
                                                </nb-list-item>

                                        </nb-list>
                                    </nb-accordion-item-body>
                                </nb-accordion-item>
                            </nb-accordion>
                        </nb-card-body>
                    </nb-card>

                    <div class="property-map">
                        <h4>{{ 'PROPERTY_DETAILS.MAP' | translate }}</h4>
                        <div class="map-inside">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m19!1m8!1m3!1d11423.007218931214!2d11.496943495291859!3d3.865484486404728!3m2!1i1024!2i768!4f13.1!4m8!3e0!4m5!1s0x108bcfe0eb54b96f%3A0xe6ee22b708f811a5!2sTECHNIPOLE%20SUP-VALOR%2C%20Ecole%20Polytechnique%20Melen%2C%20Rte%20de%20Melen%2C%20Yaounde%2C%20Cameroon!3m2!1d3.8633477!2d11.4986041!4m0!5e0!3m2!1sen!2sbd!4v1596316108414!5m2!1sen!2sbd"
                                height="320" style="border:0;" allowfullscreen=""></iframe>
                            <div class="icon">
                                <i class="fa fa-home"></i>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-lg-3 col-sm-3 col-md-3">
                <button nbTooltip="{{ 'PROPERTY_DETAILS.RESERVE_TOOLTIP' | translate }}" nbTooltipStatus="primary"
                    (click)="openWindow()"
                    style="font-family: 'Franklin Gothic Medium'; color:white; background-color: red; border-radius: 10px;"
                    nbButton>
                    <nb-icon icon="attach-2-outline" style="color: #ffffff;"></nb-icon><strong>{{
                        'PROPERTY_DETAILS.RESERVE_PROPERTY' | translate }}</strong>
                </button>

                <div class="property-sidebar">
                    <app-side-search></app-side-search>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Property Details Section End -->
<!--related propertyes start-->
<section class="feature-section spad">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title">
                    <span>{{ 'PROPERTY_DETAILS.REAL_ESTATE' | translate }}</span>
                    <h2>{{ 'PROPERTY_DETAILS.SIMILAR_PROPERTIES' | translate }}</h2>
                </div>
            </div>
        </div>
        <div class="row"><!---->
            <div class="col-md-3 col-lg-3 mb-3" *ngFor="let top of RelatedBiens | slice:0:4">
                <div class="feature-carousel" style="margin-top: 25px;">
                    <div class="feature-item">
                        <app-poperty-card [top]="top"></app-poperty-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--Related Properties end-->



<ng-template #contentTemplate1 let-data let-ref="dialogRef">
    <nb-card class="own-scroll">
        <nb-card-body nbInfiniteList>
            <div class="row">
                <div class="col-md-12">
                    <div class="card shadow-sm my-3 p-3" style="max-width: 500px; margin: auto;">
                        <div class="card-body">
                            <h5 class="card-title text-center mb-3" style="font-family: Arial, Helvetica, sans-serif;">
                                <nb-icon icon="home-outline" status="success"></nb-icon>
                                <span class="ms-2"> {{ Bien?.designation }} </span>
                                <span class="badge bg-info ms-2" style="color: white;">{{ Bien?.estmoderne ? ('PROPERTY_CARD.MODERN' | translate) : ('PROPERTY_CARD.SIMPLE' | translate) }}</span>
                            </h5>
                            <ul class="list-unstyled text-center mb-2">
                                <li>
                                    <nb-icon icon="pin-outline" status="success"></nb-icon>
                                    <span>
                                        <strong> {{ 'PROPERTY_DETAILS.LOCATION' | translate }} :</strong>
                                        {{ Bien?.ville?.nomville }}, {{ Bien?.quartier?.nomquartier }}
                                    </span>
                                </li>
                                <li class="mt-2">
                                    <nb-icon icon="pricetags-outline" status="success"></nb-icon>
                                    <span>
                                        <strong>{{ 'PROPERTY_DETAILS.PRICE_LABEL' | translate }} :</strong>
                                        <span class="text-success"> {{ Bien?.coutloyermensuel | currency:'XAF' }} / {{ 'COMMON.COST_UNITS.' + (unitecoutpar === 'Heure' ? 'HOUR' : 
                                            unitecoutpar === 'Jour' ? 'DAY' : 
                                            unitecoutpar === 'm2' ? 'SQUARE_METER' : 
                                            unitecoutpar === 'Mois' ? 'MONTH' : 
                                            unitecoutpar === 'Vente' ? 'SALE' : 'MONTH') | translate }}  </span>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form [formGroup]="firstForm" #dossierForm="ngForm" id="formId">
                        <nb-form-field>
                            <div class="row">
                                <hr>
                                <div class="col-md-4">
                                    {{ 'PROPERTY_DETAILS.VISIT_DATE' | translate }} :
                                </div>
                                <div class="col-md-4">
                                    <input nbInput type="date" min="2021-01-01"
                                        [placeholder]="'PROPERTY_DETAILS.VISIT_DATE' | translate" class="form-control"
                                        formControlName="datedescente" shape="semi-round" fieldSize="small"
                                        [ngClass]="{ 'is-invalid': submitted && f.datedescente.errors }" fullWidth
                                        required>
                                </div>
                                <div class="col-md-4">
                                    <input nbInput type="time" [placeholder]="'PROPERTY_DETAILS.VISIT_TIME' | translate"
                                        class="form-control" formControlName="heuredescente" shape="semi-round"
                                        fieldSize="small"
                                        [ngClass]="{ 'is-invalid': submitted && f.heuredescente.errors }" fullWidth
                                        required>
                                </div>
                            </div>
                            <hr>
                            <div class="row" *ngIf="data.estmeuble">
                                <div class="col-md-4">
                                    {{ 'PROPERTY_DETAILS.RESERVATION_PERIOD' | translate }}
                                </div>
                                <div class="col-md-4">
                                    <input nbInput type="date" min="2021-01-01"
                                        [placeholder]="'PROPERTY_DETAILS.START_DATE' | translate" class="form-control"
                                        formControlName="datedebutreservation" shape="semi-round" fieldSize="small"
                                        [ngClass]="{ 'is-invalid': submitted && f.datedebutreservation.errors }"
                                        fullWidth>
                                </div>
                                <div class="col-md-4">
                                    <input nbInput type="date" [placeholder]="'PROPERTY_DETAILS.END_DATE' | translate"
                                        class="form-control" formControlName="datefinreservation" shape="semi-round"
                                        fieldSize="small"
                                        [ngClass]="{ 'is-invalid': submitted && f.datefinreservation.errors }"
                                        fullWidth>
                                </div>
                            </div>
                        </nb-form-field><br />
                        <nb-form-field>
                            <div class="row">
                                <div class="col-md-4" style="text-align: justify;">
                                    {{ 'PROPERTY_DETAILS.COMMENT_PROMPT' | translate }}<br>
                                    {{ 'PROPERTY_DETAILS.COMMENT_LIMIT' | translate }}<br>
                                    <b>{{input?.value?.length || 0}}</b>/500
                                </div>
                                <div class="col-md-8">
                                    <textarea rows="2" placeholder="" nbInput fullWidth shape="semi-round"
                                        #descriptiondossier maxlength="500" id="descriptiondossier"
                                        name="descriptiondossier" formControlName="descriptiondossier" #input
                                        style="color: blueviolet;" class="form-control">
                                        </textarea>
                                </div>
                            </div>
                        </nb-form-field>
                        <br />
                        <nb-form-field>
                            <div class="row">
                                <div class="col-md-4">
                                    <label>{{ 'PROPERTY_DETAILS.CONTACT_INFO' | translate }}</label>
                                </div>
                                <div class="col-md-8">
                                    <input nbInput type="text"
                                        [placeholder]="'PROPERTY_DETAILS.CONTACT_PLACEHOLDER' | translate"
                                        class="form-control" formControlName="telclient" shape="semi-round"
                                        fieldSize="small" [ngModel]="data?.telclient"
                                        [ngClass]="{ 'is-invalid': submitted && f.telclient.errors }" fullWidth
                                        required>
                                </div>
                            </div>

                        </nb-form-field>
                        <hr>
                        <div class="row">
                            <div class="col-md-6">
                                <button nbButton (click)="close()" class="btn btn-danger  px-4 pull-left"
                                    status="danger">{{ 'PROPERTY_DETAILS.CLOSE' | translate }}</button>

                            </div>
                            <div class="col-md-6">
                                <button nbButton [disabled]="!dossierForm.form.valid" class="btn  px-4 pull-right"
                                    status="primary" (click)="rdvSubmit($event.target.valeu); close()">{{
                                    'PROPERTY_DETAILS.VALIDATE' | translate }}</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </nb-card-body>
    </nb-card>
</ng-template>
<!--
<nb-card>
    <nb-card-body>
        <section class="feature-section spad">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="section-title">
                            <span><i><b>{{ 'PROPERTY_DETAILS.SUGGESTIONS' | translate }}</b></i></span>
                            <h2>{{ 'PROPERTY_DETAILS.OTHER_VEHICLES' | translate }}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="row">
            <div class="site-section site-section-sm bg-light">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4" *ngFor="let veh of Vehicules" style="margin-top: 15px;">
                            <vehicule [voiture]="veh"></vehicule>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </nb-card-body>
</nb-card>
-->